import { groupEntityName } from '../../../../backend/features/groups/shared';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
export function useGroup(id) {
    return useStorageGet(groupEntityName, id);
}
